module.exports = __webpack_public_path__ + "static/media/error404.9ef47b5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/img/error/error404.png
// module id = 701
// module chunks = 8